import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="community-space-select"
export default class extends Controller {
  static targets = ["input", "checkbox", "selectAll", "row", "counter", "picker"]

  connect() {
    this.updateCounter()
  }

  togglePicker() {
    this.pickerTarget.classList.toggle("hidden")
  }

  filter() {
    const query = this.searchQuery()

    this.rowTargets.forEach(row => {
      const matches = row.dataset.spaceName.includes(query)
      row.classList.toggle("hidden", !matches)
    })
  }

  toggleSelectAll() {
    const shouldCheck = this.selectAllTarget.checked

    this.visibleCheckboxes().forEach(checkbox => {
      checkbox.checked = shouldCheck
    })

    this.updateCounter()
  }

  updateCounter() {
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = this.checkedCheckboxes().length
    }

    this.syncSelectAllState()
    this.dispatch("changed")
  }

  syncSelectAllState() {
    if (!this.hasSelectAllTarget) return

    const visible = this.visibleCheckboxes()
    const allChecked = visible.length > 0 && visible.every(checkbox => checkbox.checked)
    this.selectAllTarget.checked = allChecked
  }

  searchQuery() {
    return this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""
  }

  visibleCheckboxes() {
    return this.rowTargets
      .filter(row => !row.classList.contains("hidden"))
      .map(row => row.querySelector("input[type=checkbox]"))
  }

  checkedCheckboxes() {
    return this.checkboxTargets.filter(checkbox => checkbox.checked)
  }
}
